export const AUTOMAP_ADMIN_PORTAL_NAV = Object.freeze([
  { segment: "dashboard", label: "Dashboard", icon: "🏠", end: true, navGroup: "primary" },
  { segment: "dealers", label: "Dealers", icon: "🚗", navGroup: "primary" },
  { segment: "inventory-health", label: "Inventory health", icon: "📊", navGroup: "primary" },
  { segment: "whatsapp", label: "WhatsApp Leads", icon: "💬", navGroup: "primary", feature: "whatsappMonitoring" },
  { segment: "leads", label: "Leads", icon: "📬", navGroup: "primary" },
  { segment: "analytics", label: "Analytics", icon: "📈", navGroup: "primary" },
  { segment: "access-iam", label: "Access & IAM", icon: "🔐", navGroup: "primary" },
  { segment: "sponsorship-assets", label: "Sponsorship assets", icon: "✨", navGroup: "secondary" },
  { segment: "sponsorship-placements", label: "Placements", icon: "📍", navGroup: "secondary" },
  { segment: "campaigns", label: "Campaigns", icon: "📣", navGroup: "secondary" },
]);

export function getAutoMapaAdminPortalConfig() {
  return {
    portalLabel: "AutoMapa admin",
    portalSubtitle:
      "Internal administration for dealer networks, inventory quality, and lead monitoring",
    portalLoadingLabel: "Loading admin console…",
    portalNavAriaLabel: "Admin sections",
    navItems: AUTOMAP_ADMIN_PORTAL_NAV,
  };
}
